var map = {
	"./AmiyaBagchi.jpg": 620,
	"./AmiyaBagchi.png": 621,
	"./ChinmayTumbe.png": 622,
	"./DavidArnold.jpg": 623,
	"./DavidArnold.png": 624,
	"./DouglasHaynes.jpg": 625,
	"./DouglasHaynes.png": 626,
	"./DwijendraTripathi.jpg": 627,
	"./DwijendraTripathi.png": 628,
	"./GeoffreyJones.png": 629,
	"./IndiraChowdhury.jpg": 630,
	"./IndiraChowdhury.png": 631,
	"./JosephSassoon.jpg": 632,
	"./JosephSassoon.png": 633,
	"./MedhaKudaisya.jpg": 634,
	"./MedhaKudaisya.png": 635,
	"./MilanBalaban.png": 636,
	"./PrafullAnubhai.jpg": 637,
	"./PrafullAnubhai.png": 638,
	"./RamachandraGuha.png": 639,
	"./RituBirla.jpg": 640,
	"./RituBirla.png": 641,
	"./RobertPerks.png": 642,
	"./RossBassett.jpg": 643,
	"./RossBassett.png": 644,
	"./SusiePak.png": 645,
	"./SvenBeckert.png": 646,
	"./SvenBeckertOld.png": 647,
	"./TirthankarRoy.jpg": 648,
	"./TirthankarRoy.png": 649
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 619;